import { render, staticRenderFns } from "./FilterModalSave.vue?vue&type=template&id=48a900e6&scoped=true&"
import script from "./FilterModalSave.vue?vue&type=script&lang=js&"
export * from "./FilterModalSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a900e6",
  null
  
)

export default component.exports